import api from 'api';

export const loadBusinessPartners = api(
  'GET /api/financial-results/fields/business-partners'
);
export const loadAffiliates = api(
  'GET /api/financial-results/fields/affiliates'
);
export const loadApplications = api(
  'GET /api/financial-results/fields/applications'
);
export const loadExpenseTypes = api(
  'GET /api/financial-results/fields/expense-types'
);
export const loadImportance = api(
  'GET /api/financial-results/fields/importance'
);
export const loadInvoiceTypes = api(
  'GET /api/financial-results/fields/invoice-types'
);
export const loadCurrencies = api(
  'GET /api/financial-results/fields/currencies'
);
